/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createBrowserRouter, Navigate, RouterProvider, } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { grey } from "@mui/material/colors";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import RiskViewer from "./components/Root/RiskViewer";
import { CURRENT_LOWERCASE } from "./components/UserVisibleStrings";
// @ts-ignore
import { v4 as uuidv4 } from "uuid";
import { Info, Settings } from "luxon";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers";
import LoadingScreen from "./LoadingScreen";
import { useAuth } from "./AuthContext";

const theme = createTheme( {
    palette: {
        secondary: {
            main: grey[400],
        },
    },
} );


const routes = [
    {
        path: `/${CURRENT_LOWERCASE}`,
        element: <RiskViewer key = {uuidv4()}/>,
    },
    {
        path: "/*",
        element: (
            <Navigate
                replace
                to = {`/${CURRENT_LOWERCASE}`}
            />
        ),
    }

];

// Sets the first day of the week to Sunday for all calendars
Settings.defaultWeekSettings = {
    firstDay: 7,
    minimalDays: Info.getMinimumDaysInFirstWeek(),
    weekend: [ 6, 7 ],
};

const router = createBrowserRouter( routes, {
    basename: process.env.REACT_APP_PATH_PREFIX ?? "/",
} );

export default function App()
{
    const { isAuthenticated } = useAuth();
    if ( !isAuthenticated )
    {
        return <LoadingScreen/>;
    }
    return (
        <LocalizationProvider dateAdapter = {AdapterLuxon}>
            <ThemeProvider theme = {theme}>
                <CssBaseline/>
                <RouterProvider router = {router}/>
            </ThemeProvider>
        </LocalizationProvider>
    );
}
